module.exports = __webpack_public_path__ + "img/be661401454b15d67d7dad5e2f82443e.png";